module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/return_1.jpg?63e95e6ce5165ed2eeb3cc6ee8b61193";